import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { of } from 'rxjs';
import { getEnv } from '../shared';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor() { }

  basename = 'irepair'

  user = {}
  userState = []

  protected userState$ = new BehaviorSubject(this.userState[0]);

  setCurrentUser(user: any) {
    this.user = user;
    localStorage.setItem(this.basename, JSON.stringify(user));
  }

  getCurrentUser(): any {
    this.user = JSON.parse(localStorage.getItem(this.basename));
    return this.user;
  }

  isAdmin(): boolean {
    let user = this.getCurrentUser();
    if (!user) return false;
    return user.role == "ADMIN";
  }

  isBackoffice(): boolean {
    let user = this.getCurrentUser();
    if (!user) return false;
    return user.role == "BACKOFFICE";
  }

  login(user) {
    this.setCurrentUser(user);
    this.setUserState(user);
  }

  logout() {
    this.user = {};
    localStorage.clear();
    this.setUserState(this.user);

    window.location.assign("home")
  }

  setUserState(user: any): any {
    this.userState$.next(user);
  }

  getUserStates(): Observable<any[]> {
    return of(this.userState);
  }

  onUserState(): Observable<any> {
    return this.userState$.asObservable();
  }

  isLogged() {
    let user = this.getCurrentUser();
    return user && user.token && user.token != '';
  }

  getToken():string{
    return this.getCurrentUser().token;
  }

  getEmail():string{
    return this.getCurrentUser().email;
  }
}
